// @ts-nocheck
import * as React from "react";

const FolderOutline: React.FC = () => {
    return (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.845 17.0118C18.1576 16.6993 18.3332 16.2754 18.3332 15.8333V6.66667C18.3332 6.22464 18.1576 5.80072 17.845 5.48816C17.5325 5.17559 17.1085 5 16.6665 5H9.1665L7.49984 2.5H3.33317C2.89114 2.5 2.46722 2.67559 2.15466 2.98816C1.8421 3.30072 1.6665 3.72464 1.6665 4.16667V15.8333C1.6665 16.2754 1.8421 16.6993 2.15466 17.0118C2.46722 17.3244 2.89114 17.5 3.33317 17.5H16.6665C17.1085 17.5 17.5325 17.3244 17.845 17.0118Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(FolderOutline);
